// extracted by mini-css-extract-plugin
module.exports = {"profilePage":"Profile_profilePage__3teC5","title":"Profile_title__3AM2g","header":"Profile_header__3FP6n"};